import { CSSProperties } from "@material-ui/core/styles/withStyles";

import spacing from "@clockwise/web-commons/src/styles/spacing.styles";
import * as colors from "@clockwise/web-commons/src/styles/color.styles";

export const container: CSSProperties = {
  paddingRight: spacing.std,
  paddingTop: 14,
  display: "flex",
  flexDirection: "column",
};

export const containerDisabled: CSSProperties = {
  ...container,
  opacity: 0.4,
  pointerEvents: "none",
};

export const radioContainer: CSSProperties = {
  paddingRight: spacing.std,
  flexDirection: "row",
};

export const radioText: CSSProperties = {
  fontSize: 16,
  paddingLeft: 5,
  paddingRight: 20,
};

export const descriptionContainer: CSSProperties = {};

export const lunchContainer: CSSProperties = {
  display: "flex",
  justifyContent: "space-between",
  padding: "10px 0",
};

export const lunchForm: CSSProperties = {
  flex: 1,
  margin: "0px 20px 0px 0px",
};

export const lunchFields: CSSProperties = {
  marginRight: spacing.sm,
};

export const description: CSSProperties = {
  fontSize: "14px",
  color: colors.text.labelSecondary,
};

export const goal: CSSProperties = {
  paddingTop: spacing.sm,
  paddingBottom: spacing.sm,
};

export const lunchGoal: CSSProperties = {
  paddingTop: spacing.sm,
  paddingBottom: spacing.sm,
  fontSize: 16,
  marginRight: 10,
};

export const checkboxContainer: CSSProperties = {
  paddingTop: spacing.std,
};

export const toggleContainer: CSSProperties = {
  paddingTop: spacing.std,
};

export const toggleText: CSSProperties = {
  flexGrow: 1,
  color: colors.greys.darkestGrey,
  fontSize: 16,
  marginLeft: 10,
};

export const subSettingContainer: CSSProperties = {
  paddingTop: spacing.std,
};

export const subSettingDisabledContainer: CSSProperties = {
  paddingTop: spacing.std,
  opacity: 0.4,
  pointerEvents: "none",
};

export const wrapperLabel: CSSProperties = {
  padding: `${spacing.std}px 0`,
};

export const wrapperGroup: CSSProperties = {
  paddingBottom: spacing.sm,
};

export const meetingReliefThresholdForm: CSSProperties = {
  width: 120,
  marginTop: 10,
};

export const meetingReliefMinutesForm: CSSProperties = {
  width: 120,
  marginTop: 24,
};

export const intro: CSSProperties = {
  color: colors.greys.slate,
  fontSize: 14,
  lineHeight: 1.5,
  paddingTop: 10,
  paddingBottom: 15,
  paddingRight: 80,
};

export const classes = {
  toggleText,
  radioText,
};
